/* ==========================================================================
   WAQAAR — facets.js
   Shopify Storefront Filtering + sorting without page reloads, via the
   Section Rendering API. Falls back to normal links/forms without JS.
   ========================================================================== */
(() => {
  if (customElements.get('facet-filters')) return;
  const W = window.WAQAAR;

  class FacetFilters extends HTMLElement {
    connectedCallback() {
      this.sectionId = this.dataset.sectionId;
      this.root = this.closest('[data-collection], [data-search]');
      this.form = this.querySelector('[data-facet-form]');
      let t;
      this.form.addEventListener('input', (e) => {
        clearTimeout(t);
        t = setTimeout(() => this.submit(), e.target.type === 'number' ? 600 : 50);
      });
      this.form.addEventListener('submit', (e) => { e.preventDefault(); this.submit(); });
      if (!this._bound) {
        this._bound = true;
        document.addEventListener('change', (e) => { if (e.target.matches('[data-sort]')) this.submit(); });
        document.addEventListener('click', (e) => {
          const a = e.target.closest('[data-facet-link]');
          if (!a || !this.root?.contains(a)) return;
          e.preventDefault();
          this.render(new URL(a.href, window.location.origin).search.slice(1), true);
        });
        window.addEventListener('popstate', () => this.render(window.location.search.slice(1), false));
      }
    }

    params() {
      const fd = new FormData(this.form);
      const sort = document.querySelector(`#SortBy-${this.sectionId}`);
      if (sort) fd.set('sort_by', sort.value);
      const sp = new URLSearchParams();
      for (const [k, v] of fd.entries()) if (v !== '') sp.append(k, v);
      return sp.toString();
    }

    submit() { this.render(this.params(), true); }

    async render(query, push) {
      const results = this.root.querySelector('[data-results]');
      results.setAttribute('aria-busy', 'true');
      results.style.opacity = '0.45';
      try {
        const res = await fetch(`${window.location.pathname}?section_id=${this.sectionId}&${query}`);
        if (!res.ok) throw new Error(res.status);
        const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
        ['[data-results]', '[data-product-count]'].forEach((sel) => {
          const fresh = doc.querySelector(sel);
          const cur = this.root.querySelector(sel);
          if (fresh && cur) cur.innerHTML = fresh.innerHTML;
        });
        // Update facet body (counts / active chips) while keeping drawer open state.
        const freshBody = doc.querySelector('.facets__body');
        const curBody = this.querySelector('.facets__body');
        if (freshBody && curBody) {
          const open = [...curBody.querySelectorAll('details')].map((d) => d.open);
          const focusedName = document.activeElement?.name;
          curBody.innerHTML = freshBody.innerHTML;
          curBody.querySelectorAll('details').forEach((d, i) => { if (open[i] !== undefined) d.open = open[i]; });
          if (focusedName) curBody.querySelector(`[name="${CSS.escape(focusedName)}"]`)?.focus();
        }
        const freshBar = doc.querySelector('.facets-bar__btn');
        const curBar = this.root.querySelector('.facets-bar__btn');
        if (freshBar && curBar) curBar.innerHTML = freshBar.innerHTML;
        if (push) history.pushState({}, '', `${window.location.pathname}${query ? `?${query}` : ''}`);
        W.initReveal && W.initReveal(this.root);
        document.dispatchEvent(new CustomEvent('waqaar:dom-updated'));
      } catch (err) {
        window.location.search = query;
      } finally {
        results.removeAttribute('aria-busy');
        results.style.opacity = '';
      }
    }
  }
  customElements.define('facet-filters', FacetFilters);
})();
